import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";

export interface DeleteModalState {
  openModal: boolean;
  actionPath: string;
  deleteId: string;
  type: string;
}

const initialState: DeleteModalState = {
  openModal: false,
  actionPath: "",
  deleteId: "",
  type: "",
};

export const deleteModalSlice = createSlice({
  name: "deleteModal",
  initialState,
  reducers: {
    deleteModalOpenAction: (state, action) => {
      state.openModal = true;
      state.type = action.payload.type;
    },
    deleteModalCloseAction: (state) => {
      state.openModal = false;
      state.actionPath = "";
      state.deleteId = "";
      state.type = "";
    },
    deleteModalSetActionPathAction: (state, action: PayloadAction<string>) => {
      state.actionPath = action.payload;
    },
    deleteModalSetDeleteIdAction: (state, action: PayloadAction<string>) => {
      state.deleteId = action.payload;
    },
  },
});

export const {
  deleteModalOpenAction,
  deleteModalCloseAction,
  deleteModalSetActionPathAction,
  deleteModalSetDeleteIdAction,
} = deleteModalSlice.actions;

export const deleteModal = (state: RootState) => state.deleteModalState;

export default deleteModalSlice.reducer;
